import React from "react";
import { PageHeader } from "@/components/SiteLayout";

const LegalSection = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-display text-xl font-semibold tracking-tight text-slate-900">{title}</h2>
    <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export function Privacy() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Privacy Policy" intro="How MarksMan Healthcare handles information submitted through this website." />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10" data-testid="privacy-content">
          <LegalSection title="Information we collect">
            <p>When you submit an inquiry through this website, we collect the information you provide: your name, work email address, company name and any details you share about your asset, indication or timeline.</p>
          </LegalSection>
          <LegalSection title="How we use it">
            <p>Submitted information is used solely to respond to your inquiry, scope a potential engagement and communicate with you about MarksMan Healthcare services. We do not sell, rent or share your information with third parties for marketing purposes.</p>
          </LegalSection>
          <LegalSection title="Confidentiality">
            <p>All client engagements are governed by confidentiality agreements. Information about assets, evidence packages and strategy shared during an engagement is treated as strictly confidential and is never used outside the scope of that engagement.</p>
          </LegalSection>
          <LegalSection title="Data retention & your rights">
            <p>Inquiry data is retained only as long as needed for business communication. You may request access to, correction of, or deletion of your personal data at any time by contacting us through the contact form.</p>
          </LegalSection>
          <LegalSection title="Contact">
            <p>For any privacy-related questions, please reach out via the contact page. MarksMan Healthcare Communications.</p>
          </LegalSection>
        </div>
      </section>
    </>
  );
}

export function Terms() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Terms & Conditions" intro="Terms governing the use of this website and engagement with MarksMan Healthcare." />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10" data-testid="terms-content">
          <LegalSection title="About this website">
            <p>This website describes consulting services delivered by MarksMan Healthcare Communications using the proprietary JCA Matrix™ operating system. Content is provided for informational purposes and does not constitute regulatory, legal or medical advice.</p>
          </LegalSection>
          <LegalSection title="No software license">
            <p>JCA Matrix™ is an internal operating system used exclusively by MarksMan consultants. Nothing on this website constitutes an offer of software access, licensing or subscription. Clients receive consulting deliverables produced by MarksMan experts.</p>
          </LegalSection>
          <LegalSection title="Intellectual property">
            <p>JCA Matrix™, its methodology, analysis engines and all website content are the intellectual property of MarksMan Healthcare Communications. No content may be reproduced without written permission.</p>
          </LegalSection>
          <LegalSection title="Engagements">
            <p>All consulting engagements are governed by individually executed agreements, including scope, fees, timelines and confidentiality provisions. Illustrative outputs shown on this website are demonstrations and do not represent any client's data.</p>
          </LegalSection>
          <LegalSection title="Limitation of liability">
            <p>MarksMan Healthcare accepts no liability for decisions made solely on the basis of website content. Readiness assessments and recommendations are delivered under engagement terms with defined scope.</p>
          </LegalSection>
        </div>
      </section>
    </>
  );
}
